<template>
    <div v-if="ticket_status" class="warranty-flag excerpt-card">
        <!-- request-->
        <img v-if="ticket_status === 'request' && ticket_type === 'warranty'" src="@/assets/images/red-ribbon.png" alt="" />
        <img v-if="ticket_status === 'request' && ticket_type === 'repair'" src="@/assets/images/repair_request_red.svg" alt="" />

        <!-- open-->
        <img v-if="ticket_status === 'open' && ticket_type === 'warranty'" src="@/assets/images/active-warranty.png" alt="" />
        <img v-if="ticket_status === 'open' && ticket_type === 'repair'" src="@/assets/images/repair_active_red.svg" alt="" />
        <!-- close-->
        <img v-if="ticket_status === 'closed' && ticket_type === 'warranty'" src="@/assets/images/history-warranty.png" alt="" />
        <img v-if="ticket_status === 'closed' && ticket_type === 'repair'" src="@/assets/images/repair_closed_red.svg" alt="" />
    </div>
</template>

<script>
export default {
    props: ['ticket_status', 'ticket_type']
};
</script>
